module.exports = __webpack_public_path__ + "static/relaxing-woman-28d939462c91881d6c55fad3197bcd7c.jpg";